import { customFetch } from '@skytech/auth'
import type { Translation, PostTranslationPayload, Locale } from '@skytech/types'

import { get } from '@/util/auth'

import type { Form } from './types'

const formResources = {
  getForm: () => get<Form>('form/:code'),
  getTranslationList: () => customFetch<Record<Locale, Translation>>({ path: 'translations/form' }),

  // mutations
  postTranslation: (postTranslationPayload: PostTranslationPayload) =>
    customFetch({ path: 'translations/form', method: 'POST', data: postTranslationPayload }),
}

export default formResources
